
import { mapState } from 'vuex'
import subNav from '~/components/common/subNav.vue'
import fixTabs from '@/components/basic/fixTab/index.vue'
import Companyhead from '~/components/company/companyhead.vue'
import License from '~/components/company/license.vue'
import affiliatedEnterprise from '~/components/company/affiliatedEnterprise.vue'
import controlStatement from '~/components/company/controlStatement.vue'
import seniorExecutive from '~/components/company/seniorExecutive.vue'
import trademarkReg from '~/components/company/trademarkReg.vue'
import officialReg from '~/components/company/officialReg.vue'
import Licensedig from '~/components/company/licensedig.vue'
import Related from '~/components/company/Related.vue'
import software from '~/components/company/v2/software.vue' // 相关软件
import Dialog from '~/components/common/Dialog.vue'
import noData from '~/components/common/noData.vue'
import relationTree from '@/components/dealer/chart/tree.vue'
import shangshiInfo from '~/components/company/v2/shangshiInfo.vue'
import changerecord from '@/components/company/changerecord.vue'
import Hide from '@/components/dealer/hide.vue'
export default {
  components: {
    Hide,
    'sub-nav': subNav,
    Dialog,
    fixTabs,
    Companyhead,
    License,
    affiliatedEnterprise,
    controlStatement,
    seniorExecutive,
    trademarkReg,
    officialReg,
    Licensedig,
    Related,
    software,
    relationTree,
    'shangshi-info': shangshiInfo,
    'no-data': noData,
    changerecord
  },
  provide() {
    return {
      detail: this.company_detail,
      company_detail: this.company_detail,
      softResult: this.softResult,
      downurl: this.downurl
    }
  },
  asyncData({ $api, app, store, route, redirect, res, $axios, $cookies, req, $serverlog, error }) {
    const code = route.params.id && route.params.id.split('.')[0]
    if (!code) {
      res.statusCode = 404
      return {
        isShow: true
      }
    }
    let tratername = route?.query?.tratername
    let tratercode = route?.query?.tratercode
    const wikifxagg = $api.common
      .V3(
        {
          code,
          companyId: code, // CPD202412111418401041298563839
          type: 2,
          userId: store.state.user.userId || ''
        },
        { Routes: 'wikifxagg$company_detail,wikifxagg$company_tips,wikifxagg$get_company_software_list_diandian_v2,wikifxagg$family_tree_entry_setting' }
      )
      .catch(() => {})
    const wikidatadownload = $api.download.init().catch(() => {
      console.log('wikidatadownload')
    }) // 下载链接

    const changehistoryall = $api.common
      .V3(
        // 获取变更历史
        {
          code,
          type: 2, // 1交易商 2公司 3牌照 4软件
          pushGenerationTime: 0,
          pageIndex: 1,
          pageSize: 5,
          basicSubTabCodeList: [],
          evaluateTabCodeList: [],
          dateTabCodeList: [],
          pageType: 1
        },
        { Routes: 'wikifxagg$changehistoryall' }
      )
      .catch(() => {
        console.log('changehistoryall')
      })

    // 上市信息
    const shangshiTask = $api.common
      .V3(
        {
          companyId: code
        },
        { Routes: 'wikifxagg$company_listing_by_company' }
      )
      .catch(() => {})

    return Promise.all([wikifxagg, wikidatadownload, changehistoryall, shangshiTask]).then((result) => {
      // result[0].wikifxagg.company_detail.data.main.websiteList = []
      if (!result[0]?.wikifxagg?.company_detail?.data?.main) {
        res.statusCode = 404
        return {
          isShow: true
        }
      }
      const relatedTraders = result[0]?.wikifxagg?.company_detail?.data?.relatedTraders || []
      // console.log('relatedTraders', relatedTraders)
      relatedTraders?.forEach((item) => {
        item.color = item?.core?.color
        item.annotation = item?.core?.annotation
        item.logo = item?.basic?.logo
        item.localShortName = item?.basic?.showName
        item.isvr = item?.expand?.vr
        item.score = item?.core?.totalScore
        item.showLabel = []
        item?.labels?.forEach((aa) => {
          aa?.labels?.forEach((bb) => {
            item.showLabel.push(bb.label)
          })
        })
      })

      let navData = []
      if (!tratercode && relatedTraders?.length > 0) {
        tratername =
          relatedTraders[0]?.basic?.localShortName && relatedTraders[0]?.basic?.englishShortName && relatedTraders[0]?.basic?.localShortName != relatedTraders[0]?.basic?.englishShortName
            ? relatedTraders[0]?.basic?.englishShortName + ' ' + relatedTraders[0]?.basic?.localShortName
            : relatedTraders[0]?.basic?.localShortName || relatedTraders[0]?.basic?.englishShortName
        tratercode = relatedTraders[0]?.traderCode
      }
      if (tratercode && tratercode != 'null') {
        navData = [
          {
            link: '/',
            text: '20641',
            type: 'a'
          },
          {
            link: `/dealer/${tratercode}.html`,
            text: tratername,
            type: 'a'
          },
          {
            link: '#',
            text: result[0]?.wikifxagg?.company_detail?.data?.main?.legalName,
            type: 'span',
            translation: true
          }
        ]
      } else {
        navData = [
          {
            link: '/',
            text: '20641',
            type: 'a'
          },
          {
            link: '#',
            text: result[0]?.wikifxagg?.company_detail?.data?.main?.legalName,
            type: 'span',
            translation: true
          }
        ]
      }

      const _softResult = result[0]?.wikifxagg?.get_company_software_list_diandian_v2?.data
      store.commit('setapphead', {
        ico: result[0]?.wikifxagg?.company_detail?.data?.main?.ico,
        name: result[0]?.wikifxagg?.company_detail?.data?.main?.fullName
      })

      const _shangshi = result[3]?.wikifxagg?.company_listing_by_company?.data

      return {
        code,
        downurl: result[1] ? result[1] : {},
        familytree: result[0]?.wikifxagg?.family_tree_entry_setting?.data || {},
        treedata: {
          code,
          ico: result[0]?.wikifxagg?.company_detail?.data?.main?.ico,
          name: result[0]?.wikifxagg?.company_detail?.data?.main?.fullName
        },
        navData,
        relatedTraders, // 关联交易商
        isCollect: result[0]?.wikifxagg?.company_detail?.data?.companyExpand?.isCollect, // 是否收藏
        licenses: result[0]?.wikifxagg?.company_detail?.data?.licenses || [], // 拍照信息
        company_tips: result[0]?.wikifxagg?.company_tips?.data || {},
        main: result[0]?.wikifxagg?.company_detail?.data?.main || {}, // 头部信息
        company_detail: result[0]?.wikifxagg?.company_detail?.data || {},
        softResult: _softResult, // 相关软件
        shangshi: _shangshi,
        changrecord: result[2]?.wikifxagg?.changehistoryall?.data || {}
      }
    })
  },
  data() {
    return {
      licensesshow: false,
      licensedata: {},
      isShow: false,
      softResult: [],
      shangshi: [],
      changrecord: {} // 变更记录
    }
  },
  head() {
    return {
      title: this.$t('54927').replace('{0}', this.main?.fullName),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('54924').replace('{0}', this.main?.fullName)
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    newtab() {
      const arr = []
      if (this.shangshi?.length > 0) {
        // 上市信息
        arr.push({ name: this.$t('31059'), dataId: 'shangshi' })
      }
      if (this.company_detail?.officers?.length > 0) {
        // 董事/高管
        arr.push({ name: this.$t('55035'), dataId: 'senior' })
      }
      if (this.relatedTraders?.length > 0) {
        // 关联品牌
        arr.push({ name: this.$t('54793'), dataId: 'related' })
      }
      if (this.licenseslist?.length > 0) {
        // 牌照信息
        arr.push({ name: this.$t('55269'), dataId: 'license' })
      }
      if (this.softResult?.serverList?.length > 0 || this.softResult?.items?.length > 0) {
        // 旗下软件
        arr.push({ name: this.$t('55030'), dataId: 'software' })
      }
      if (this.familytree?.isShow) arr.push({ name: this.$t('56879'), dataId: 'qytp' })
      if (this.company_detail?.relates?.length > 0) {
        // 关联企业
        arr.push({ name: this.$t('39926'), dataId: 'relatedcompanies' })
      }
      if (this.company_detail?.statements?.length > 0) {
        // 控制声明
        arr.push({ name: this.$t('55034'), dataId: 'controlstatement' })
      }
      if (this.company_detail?.multiTrademarkRegistrationList?.length > 0) {
        // 商标注册
        arr.push({ name: this.$t('55036'), dataId: 'logo' })
      }
      if (this.company_detail?.officialRegistryNumberList?.length > 0) {
        // 官方登记号
        arr.push({ name: this.$t('55037'), dataId: 'registration' })
      }
      if (this.changrecord?.count > 0) {
        // 变更记录
        arr.push({ name: this.$t('53749'), dataId: 'changrecord' })
      }
      return arr
    },
    licenseslist() {
      if (this.licensesshow) {
        return this.licenses
      } else {
        return this.licenses.slice(0, 4)
      }
    }
  },
  mounted() {
    this.$refs.hideref.open(this.code, 2, () => {}, false)
    console.log(this.company_detail, 8876, this.$store.state.newhost)
    console.log('softResult', this.softResult)
    this.setHistory()
    console.log('this.company_detail.officers', this.company_detail.officers)
    console.log('this.shangshi', this.shangshi)
  },
  methods: {
    setsollchangercord() {
      // 变更历史跳转
      this.newtab.forEach((item, ind) => {
        if (item.dataId == 'changrecord') {
          this.$refs.dealerFixedTab.scrollToSection(item, ind)
        }
      })
    },
    setHistory() {
      // 存入浏览历史
      if (!this?.main?.companyId) return
      const directArr = this.$cookies.get('companyHistory') || '' // 获取本地访问交易商记录
      let arr = directArr?.split(',')
      const trader = this.main?.companyId
      const s = arr.findIndex((item) => item == this?.main?.companyId)
      if (s < 0) {
        arr.unshift(trader)
        arr = arr?.slice(0, 30)
        const str = arr.join(',')
        this.$cookies.set('companyHistory', str, {
          path: '/',
          domain: this.$store.state.cookieHost
        })
      } else {
        arr.splice(s, 1)
        arr.unshift(trader)
        arr = arr?.slice(0, 30)
        const str = arr.join(',')
        this.$cookies.set('companyHistory', str, {
          path: '/',
          domain: this.$store.state.cookieHost
        })
      }
    },
    openlicensefn(item) {
      console.log(item, 88876)
      this.$refs.hideref.open(item.regulationId, 1, () => {
        this.licensedata = item
        this.$nextTick(() => {
          this.$refs.morelicense.open()
        })
      })
    }
  }
}
